/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Alipay_App_IdInputs */

const en_admin_settings_fields_alipay_app_id = /** @type {(inputs: Admin_Settings_Fields_Alipay_App_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App ID`)
};

const zh_admin_settings_fields_alipay_app_id = /** @type {(inputs: Admin_Settings_Fields_Alipay_App_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用 ID`)
};

/**
* | output |
* | --- |
* | "App ID" |
*
* @param {Admin_Settings_Fields_Alipay_App_IdInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_alipay_app_id = /** @type {((inputs?: Admin_Settings_Fields_Alipay_App_IdInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Alipay_App_IdInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_alipay_app_id(inputs)
	return zh_admin_settings_fields_alipay_app_id(inputs)
});
export { admin_settings_fields_alipay_app_id as "admin.settings.fields.alipay_app_id" }